import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const QUERY = gql`
  query randomWeek {
    randomWeek {
      id
      plan {
        date
        meal
        amount
        unit {
          name
          sign
        }
        dish {
          id
          name
          recipe
        }
      }
    }
  }
`;

const useRandomWeek = () => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return { loading, error, refetch, data: data?.randomWeek };
};

export default useRandomWeek;
